import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/gradeActions';
import { Actions as EMPLOYEEACTIONS } from '../../store/actions/employeeActions';

import Select from 'react-select';

const AgreementGrade = ({
  removeGradeLock,
  forNewEmployee,
  disabled,
  gradeSetApplyModal,
  gradesGetList,
  gradeList,
  isApplied,
  isFirstPage,
  isLast,
  isPermitted,
  hideButton,
  matchingGrade
}) => {

  const [selectedGrade, setSelectedGrade] = useState(false);
  const gradeOptions = gradeList?.map(item => ({
    label: item.name,
    value: item.id,
    item: item
  }))

  useEffect(() => {
    if (!gradeList) {
      gradesGetList()
    }
  }, []);

  useEffect(() => {
    setSelectedGrade(gradeOptions?.find(grade => grade.value == matchingGrade?.id) || null)
  }, [matchingGrade])

  const GradeList = ({ }) => {

    if (forNewEmployee && (!isFirstPage && !isApplied) && (!isFirstPage && !matchingGrade)) return null

    return (
      <div className="col-lg-4 col-xs-4" style={{ paddingLeft: isFirstPage ? undefined : 0 }}>
        <div className="form-material">
          <label htmlFor="material-text">Grade</label>
          <Select
            options={gradeOptions}
            value={selectedGrade}
            onChange={setSelectedGrade}
            name='grade'
            isDisabled={disabled || isApplied}
          />
        </div>
      </div>
    )
  }

  const ApplyGradeButton = ({ }) => {

    if (disabled || !selectedGrade || forNewEmployee && ((isFirstPage && selectedGrade && isApplied) || (!isFirstPage && !isApplied))) return null

    return (
      <div className='col-lg-2 col-xs-2' style={{ paddingLeft: 0 }}>
        <button
          className="btn btn-success pull-left"
          type="submit"
          style={{ marginTop: '1.25rem' }}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()

            gradeSetApplyModal(selectedGrade.item)
          }}
        >
          Apply Grade
        </button>
      </div>
    )
  }

  const UnlockGrade = ({ }) => {

    if (!disabled || !isPermitted || !isLast || hideButton) return null

    return (
      <div className="col-lg-5 col-xs-5" style={{ minHeight: 83 }}>

        <div style={{ paddingTop: forNewEmployee ? 12 : 0 }}>
          <p
            className="pull-left"
            style={{ marginBottom: 0 }}
          >
            {forNewEmployee && 'Confirm the following Grade Salary settings.'}
          </p>
          <a
            className="pull-left"
            style={{ paddingTop: forNewEmployee ? '0' : '2rem', cursor: 'pointer' }}
            onClick={(e) => {
              e.preventDefault()
              removeGradeLock()
            }}
          >
            Click here to remove the grade lock
          </a>
        </div>

      </div>
    )
  }

  if (!gradeList?.[0]) return null


  return (
    <>
      <GradeList />
      <ApplyGradeButton />
      <UnlockGrade />

    </>
  )

}

const mapStateToProps = (state, ownProps) => {
  const gradeList = state.grades.gradeList

  const passedSalary = ownProps.salary
  const lastSalary = state?.employee?.salaries?.[state?.employee?.salaries?.length - 1]

  const gradeFromPassedSalary = passedSalary?.grade
  const gradeFromAppliedGrade = state.grades?.apply?.id
  const gradeFromLatestSalary = lastSalary?.grade

  const isLast = passedSalary?.id == lastSalary?.id

  const foundGrade = !!gradeFromAppliedGrade ? gradeFromAppliedGrade : (isLast ? gradeFromLatestSalary : gradeFromPassedSalary)

  const matchingGrade = gradeList?.find(g => (foundGrade == g.id))

  const disabled = ownProps.disabled || !!gradeFromPassedSalary


  return {
    isPermitted: state?.permissions?.my?.permissions?.people != "Read",
    isApplied: !!gradeFromAppliedGrade,
    isLast,
    disabled,
    gradeList,
    matchingGrade,
    ...state.grades,
  }
}

const mapDispatchToProps = dispatch => ({
  removeGradeLock: () => dispatch(EMPLOYEEACTIONS.removeGradeLock()),
  gradesGetList: () => dispatch(ACTIONS.gradesGetList()),
  gradeSetApplyModal: (status) => dispatch(ACTIONS.gradeSetApplyModal(status)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgreementGrade) 
